import { useLinkStatus } from 'next/link';
import { useEffect } from 'react';
import { useGlobalLoaderContext } from '../components/providers/global-loader-context';
export const LinkStatusInjector = () => {
  const {
    pending
  } = useLinkStatus();
  const {
    setIsNonBlockingLoaderVisible
  } = useGlobalLoaderContext();
  useEffect(() => {
    if (!pending) {
      return undefined;
    }
    setIsNonBlockingLoaderVisible(true);
    return () => {
      setIsNonBlockingLoaderVisible(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pending]);
  return null;
};